import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

import axios from "axios";
import { GetCookieData, GetCookieToken, GetUserInfo } from "../Cookie/GetCookie";
import { useFormik } from "formik";
import * as Yup from "yup";
import { fullMonthNames } from "../../common/data/monthName";
import { ConvertDate, getDateTime } from "../Function/ConvertDate";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import { ListItemAvatar } from "@mui/material";
import ApproveHistory from "./ApproveHistory";
import { checkFinalApprove } from "../Function/CheckFinalApprove";
import { leaveConfigFlow } from "./LeaveStepHelper";
import * as loadingBar from "../TESTPage/loadingBar.json";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
const ModalViewOrEditTableForm = ({
  userInfo,
  getUserApprove,
  getFlowApprove,
  configForm,
  modalState,
  modalLeaveData,
  ToggleModalLeaveData,
  handleEditLeaveDataEdit,
  handleEditDataInApproveTable,
  leaveDataEdit,
  setLeaveDataEdit,
  handleOpenSubmitSuccess,
  allDayCancel,
  setAllDayCancel,
  getAllDayCancel,
  selectDayCancel,
  setSelectDayCancel,
  getDataCancelDayById,
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");
  const user_id = user?.user_id;
  const leaderInfo = userInfo?.leader;
  const user_position =
  userPosition &&
  userPosition
    .sort((a, b) => a?.position_id - b?.position_id)
    ?.find((a) =>
      a?.position_id === 2
        ? 2
        : a?.position_id === 3
        ? 3
        : a?.position_id === 4
        ? 4
        : a?.position_id === 5
        ? 5
        : a?.position_id === 6
        ? 6
        : a?.position_id === 7
        ? 7
        : null
    )?.position_id;

  const [leavePerson, setLeavePerson] = useState([]);
  const [leaveVacation, setLeaveVacation] = useState([]);
  const [holiday, setHoliday] = useState([]);
  const [fileKey, setFileKey] = useState(0);
  const [selectDayCancel2, setSelectDayCancel2] = useState([]);

  const formValidate = useFormik({
    enableReinitialize: true,

    initialValues: {
      leave_reason: leaveDataEdit?.leave_reason || "",
      abroad_for: leaveDataEdit?.abroad_for || "",
      abroad_country: leaveDataEdit?.abroad_country || "",
      ordinate_ever: leaveDataEdit?.ordinate_ever || "",
      ordinate_temple: leaveDataEdit?.ordinate_temple || "",
      ordinate_temple_place: leaveDataEdit?.ordinate_temple_place || "",
      ordinate_live_temple: leaveDataEdit?.ordinate_live_temple || "",
      ordinate_live_place: leaveDataEdit?.ordinate_live_place || "",
      conscription_from: leaveDataEdit?.conscription_from || "",
      conscription_place: leaveDataEdit?.conscription_place || "",
      conscription_date: leaveDataEdit?.conscription_date || "",
      conscription_for: leaveDataEdit?.conscription_for || "",
      conscription_to_place: leaveDataEdit?.conscription_to_place || "",
      leave_name: leaveDataEdit?.leave_name || "",
      spouse_name: leaveDataEdit?.spouse_name || "",
      spouse_country: leaveDataEdit?.spouse_country || "",
      outside_place: leaveDataEdit?.outside_place || "",
      practice_reason: leaveDataEdit?.practice_reason || "",
      contact_address: leaveDataEdit?.contact_address || "",
    },

    validationSchema: Yup.object().shape({
      leave_reason: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 1 || configForm?.form_type === 11
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      abroad_for: Yup.string().when("configForm", {
        is: () => (configForm?.form_type === 3 || configForm?.form_type === 7) && true,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      abroad_country: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 3 || configForm?.form_type === 7
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_temple: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_temple_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_live_temple: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      ordinate_live_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 4,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_from: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_for: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      conscription_to_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 6,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      leave_name: Yup.string().when("configForm", {
        is: () => (configForm?.form_type === 7 ? true : false),
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      spouse_name: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 8,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      spouse_country: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 8,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      outside_place: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 9,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      practice_reason: Yup.string().when("configForm", {
        is: () => configForm?.form_type === 10,
        then: Yup.string().required("กรุณาระบุข้อมูล"),
        otherwise: Yup.string().notRequired(),
      }),
      contact_address: Yup.string().when("configForm", {
        is: () =>
          configForm?.form_type === 1 || configForm?.form_type === 2
            ? true
            : false,
        then: Yup.string().required("กรุณาระบุสถานที่ติดต่อ"),
        otherwise: Yup.string().notRequired(),
      }),
    }),

    onSubmit: async () => {
      await handleEditLeaveDataEdit(leaveDataEdit?.leave_data_id);
      await handleEditDataInApproveTable();
      // await ToggleModalLeaveData();

      await DeleteCancelLeaveDay(leaveDataEdit?.leave_data_id);

      // await handleOpenSubmitSuccess();
      await ToggleModalLeaveData();
      await handleOpenSubmitSuccess();
    },
  });

  const DeleteCancelLeaveDay = async (id) => {
    let dayInTable;
    let checkSelectDay;
    const getDayBeforeDelete = async () => {
      try {
        const url = baseURL + "/api/leave/cancel/list/datatable";
        const params = new URLSearchParams({
          page: 1,
          size: 10000,
          "order[0]": "date_cancel",
          "order[1]": "ASC",
          "filter[leave_data_id][0]": id,
          // "filter[cancel_date_status][0]": 
        });
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        };
        const res = await axios.get(url, config);
        return res;
      } catch (err) {
        console.error(err);
      }
    };
    dayInTable = await getDayBeforeDelete();
    (await dayInTable?.data?.result) &&
      (await dayInTable?.data?.result?.map(async (item) => {
        const res = await axios.delete(
          baseURL + `/api/leave/cancel/list/${item?.id_leave_date_list}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }));

    checkSelectDay = await selectDayCancel;
    (await checkSelectDay) &&
      (await checkSelectDay?.map(async (item) => {
        await SubmitCancelLeaveDay(item);
      }));
  };

  const SubmitCancelLeaveDay = async (item) => {
    try {
      const res = await axios.post(
        baseURL + "/api/leave/cancel/list/save",
        {
          leave_data_id: item?.leave_data_id,
          date_cancel: ConvertDate(item?.date_cancel)?.toOnlyDate(),
          leave_from_timetype: item?.leave_from_timetype,
          leave_to_timetype: item?.leave_to_timetype,
          cancel_date_status : 1
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (e, field) => {
    setLeaveDataEdit((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const [vacationRemain, setVacationRemain] = useState({
    vacationDayPrev : null,
    vacationUse : null,
    vacationRemaining : null,
  });

  const getVacationRemain = async () => {
    try {
      const res = await axios.get(
        baseURL + `/api/leave/chart/1/${CheckBudgetYear()}/${user_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let result = res?.data?.result;
      let vacationDayPrev = 0;
      let vacationUse = 0;
      let vacationRemaining = 0;
      vacationDayPrev = result?.years_worked >= 10
            ? (result?.vacation_limit_day?.max + (result?.vacation_over10?.vacation_day_prev || 0)) > 30
              ? 30 : result?.vacation_limit_day?.max + (result?.vacation_over10?.vacation_day_prev || 0)
            : (result?.vacation_limit_day?.max + (result?.vacation_under10?.vacation_day_prev || 0)) > 30 
              ? 30 : result?.vacation_limit_day?.max + (result?.vacation_under10?.vacation_day_prev || 0)
      vacationUse = result?.vacation_limit_day?.use
      vacationRemaining = vacationDayPrev - vacationUse;
      setVacationRemain((prev) => ({
        ...prev,
        vacationDayPrev : vacationDayPrev,
        vacationUse : vacationUse,
        vacationRemaining : vacationRemaining,
      }));
    } catch (err) {}
  };

  const getLeavePerson = async (dmy_s = null, dmy_t = null) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 1,
        "filter[leave_type_id][0]": 2,
        "filter[leave_dmy_start][0]": ConvertDate(new Date(dmy_s)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_dmy_end][0]": ConvertDate(new Date(dmy_t)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_status][0]": 5,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeavePerson(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getLeaveVacation = async (dmy_s = null, dmy_t = null) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 5,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[form_type][0]": 2,
        "filter[leave_dmy_start][0]": ConvertDate(new Date(dmy_s)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_dmy_end][0]": ConvertDate(new Date(dmy_t)).toOnlyDate() ?? ConvertDate(new Date()).toOnlyDate(),
        "filter[leave_status][0]": 5,
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveVacation(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getHoliday = (year) => {
    axios
      .get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setHoliday(res?.data?.result);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getHoliday(new Date()?.getFullYear());
  }, []);

  const [leaveDataFromSelect, setLeaveDataFromSelect] = useState([])
  const [hideTimeTypeSelect, setHideTimeTypeSelect] = useState(true)

  const getLeaveDataFromSelect = async () => {
    setLeaveDataFromSelect([])
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[leave_status][0]": 0,
        "filter[leave_status][1]": 2,
        "filter[leave_status][2]": 3,
        "filter[leave_status][3]": 4,
        "filter[leave_status][4]": 5,
        "filter[leave_status][5]": 7,
        "filter[leave_status][6]": 9,
        "filter[budget_year][0]": leaveDataEdit?.budget_year,
        "filter[leave_dmy_start][0]": ConvertDate(leaveDataEdit?.leave_from_date)?.toDateISO(),
        "filter[leave_dmy_end][0]": ConvertDate(leaveDataEdit?.leave_to_date)?.toDateISO(),
      });
      // leaveDataEdit?.budget_year && params.append("filter[budget_year][0]", leaveDataEdit?.budget_year);
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      const resultArr = res.data?.result;
      if (configForm?.form_type !== 3) {
        for (const i in resultArr) {
         if (resultArr[i]?.leave_data_id !== leaveDataEdit?.leave_data_id) {
          leaveDataFromSelect.length !== 0 ? setLeaveDataFromSelect((prev) => [...prev,resultArr[i]]) : setLeaveDataFromSelect([resultArr[i]])
         }
      }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getDateCancelDayAfterRequestCancelById = async (id = "", allCancel = []) => {
    try {
      const url = baseURL + "/api/leave/cancel/list/datatable";
      const params = new URLSearchParams({
        page: 1,
        size: 10000,
        "order[0]": "date_cancel",
        "order[1]": "ASC",
        "filter[leave_data_id][0]": id,
        "filter[cancel_date_status][0]": 2
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setSelectDayCancel2(res?.data?.result);
      // res?.data?.result &&
      //   res?.data?.result?.map((item) => {
      //     if (
      //       allCancel?.find(
      //         (a) =>
      //           new Date(a?.date_cancel)?.toLocaleDateString() ===
      //           new Date(item?.date_cancel)?.toLocaleDateString()
      //       )
      //     ) {
      //       setAllDayCancel((prev) =>
      //         prev.filter(
      //           (a) =>
      //             new Date(a?.date_cancel)?.toLocaleDateString() !==
      //             new Date(item?.date_cancel)?.toLocaleDateString()
      //         )
      //       );
      //     }
      //   });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getLeaveDataFromSelect()
  }, [leaveDataEdit?.leave_from_date,leaveDataEdit?.leave_to_date])

  const CheckCancelDayIsweekEndOrThaiPublic = (date) => {
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (!isWeekend(date) && !isThaiPublic(date)) {
      return false;
    }
    return true;
  };

  const calculateLeaveDays = (
    leavefromDate,
    leavefromTime,
    leavetoDate,
    leavetoTime
  ) => {
    let cutDay = selectDayCancel.length ?? 0;
    let giveTime = 0;
    selectDayCancel.length !== 0 && selectDayCancel.map((item) => {
      if ((item.leave_from_timetype === "1" && item.leave_to_timetype === "1") || (item.leave_from_timetype === "2" && item.leave_to_timetype === "2")) {
        giveTime += 0.5;
      }
    })

    let sum
    const startTimestamp = leavefromDate.getTime();
    const endTimestamp = leavetoDate.getTime();
    selectDayCancel.length > 0 ? selectDayCancel.forEach(element => {
      const checkDate =  new Date(new Date(element.date_cancel)?.setHours(0, 0, 0, 0));
      const checkTimestamp = checkDate.getTime();
      if (checkTimestamp >= startTimestamp && checkTimestamp <= endTimestamp) {
        sum = 0 - cutDay + giveTime;
      } else {
        sum = 0
      }
    }) : sum = 0;
    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (leavefromTime === "1" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0;
      return sum;
    }
    if (leavefromTime === "1" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum === 0 ? sum : sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum === 0 ? sum : sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 1;
      return sum;
    }
  };

  const convertDate = (date) => {
    const DateSplit = {
      toDate: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[2];
        return part2;
      },
      toMonth: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[1];
        return fullMonthNames[part2 - 1];
      },
      toYear: () => {
        const part1 = date?.split("T")[0];
        const part2 = part1?.split("-")[0];
        return parseInt(part2) + 543;
      },
    };

    return DateSplit;
  };

  useEffect(() => {
    // const getSeq = async (leave_user_id) => {
    //   await FetchAxiosGet(`/api/approvalSequence/${leave_user_id}`, token).then(async response => {
    //     let seq = response?.result
    //     let index = seq.findIndex(x => x?.user_id == user_id)
    //     console.log(index);
    //     let next = checkFinalApprove(leaveDataEdit?.form_type, seq[index]?.position_id) ? (seq[index]) : (seq[index - 1])
        
    //     setLeaveDataEdit((prev) => ({
    //       ...prev,
    //       send_to: `${next?.users_position_name}${next?.cont_to_main}`
    //     }))
    //     console.log(leave_user_id,`${next?.users_position_name}${next?.cont_to_main}`,seq, next);
    //   }).catch(error => console.error("Error:", error))
    // }
    // getSeq(leaveDataEdit?.user_id)
  }, [leaveDataEdit?.user_id])
  

  useEffect(() => {
    // getLeavePerson();
    // getLeaveVacation();
    getVacationRemain();
    getAllDayCancel(leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date);
    getDateCancelDayAfterRequestCancelById(leaveDataEdit?.leave_data_id)
  }, [leaveDataEdit?.leave_data_id]);

  const calculateCancelLeaveDay = (
    leavefromType,
    leaveToType,
    leaveDays,
    eTarget,
    DateItem
  ) => {
    if (leavefromType === "1" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
    } else if (leavefromType === "1" && leaveToType === "1") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays === 0 ? leaveDays : leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    } else if (leavefromType === "2" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays === 0 ? leaveDays : leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    }
  };

  useEffect(() => {
    leaveDataEdit?.leave_from_date > leaveDataEdit?.leave_to_date && setLeaveDataEdit((prev) => ({
      ...prev,
      leave_to_date: leaveDataEdit?.leave_from_date,
    }));
  }, [leaveDataEdit?.leave_from_date])

  // useEffect(() => {
  //   // if (leaveDataEdit?.form_type !== 2) {
  //   //   const leaveDays = calculateLeaveDays(
  //   //   leaveDataEdit?.leave_from_date,
  //   //   leaveDataEdit?.leave_from_timetype,
  //   //   leaveDataEdit?.leave_to_date,
  //   //   leaveDataEdit?.leave_to_timetype
  //   // );
  //   // setLeaveDataEdit((prev) => ({
  //   //   ...prev,
  //   //   leave_days: leaveDays,
  //   // }));
  //   // } 
  //   // else {
  //   //   getAllDayCancel(leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date);
  //   //   const leaveDays = calculateLeaveDays(
  //   //     leaveDataEdit?.leave_from_date,
  //   //     leaveDataEdit?.leave_from_timetype,
  //   //     leaveDataEdit?.leave_to_date,
  //   //     leaveDataEdit?.leave_to_timetype
  //   //   );
      
  //   //   setLeaveDataEdit((prev) => ({
  //   //     ...prev,
  //   //     leave_days: leaveDays,
  //   //   }));
  //   // }
  // }, [leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date])
  
  const [getEventLeaveFrom, setGetEventLeaveFrom] = useState(null)
  const setLeaveFromDate = (e) => {
    setGetEventLeaveFrom(e)
  }

  useEffect(() => {
    if (getEventLeaveFrom !== null) {
      if (leaveDataEdit?.leave_to_date !== null) {
          const leaveDays = calculateLeaveDays(
            getEventLeaveFrom,
            leaveDataEdit?.leave_from_timetype,
            getEventLeaveFrom,
            leaveDataEdit?.leave_to_timetype
          );
          setLeaveDataEdit((prev) => ({
            ...prev,
            leave_from_date: getEventLeaveFrom,
            getEventLeaveFrom,
            leave_days: leaveDays,
          }));
        }
        if (leaveDataEdit?.form_type === 2) {
          getAllDayCancel(getEventLeaveFrom, getEventLeaveFrom);
        }
        setLeaveDataEdit((prev) => ({
          ...prev,
          leave_from_date: getEventLeaveFrom,
          leave_to_date: getEventLeaveFrom,
        }));
    }
  }, [getEventLeaveFrom])
  

  const [getEventLeaveTo, setGetEventLeaveTo] = useState(null)
  const setLeaveToDate = (e) => {
    setGetEventLeaveTo(e)
  }

  useEffect(() => {
    if (getEventLeaveTo !== null) {
      if (leaveDataEdit?.leave_from_date !== null) {
        const leaveDays = calculateLeaveDays(
          new Date( new Date(leaveDataEdit?.leave_from_date).setHours(0,0,0,0)),
          leaveDataEdit?.leave_from_timetype,
          getEventLeaveTo,
          leaveDataEdit?.leave_to_timetype
        );
        setLeaveDataEdit((prev) => ({
          ...prev,
          leave_to_date: getEventLeaveTo,
          leave_days: leaveDays,
        }));
      }
      if (leaveDataEdit?.form_type === 2) {
        getAllDayCancel(
          new Date(leaveDataEdit?.leave_from_date),
          getEventLeaveTo
        );
      }
      setLeaveDataEdit((prev) => ({
        ...prev,
        leave_to_date: getEventLeaveTo,
      }));
    }
    
  }, [getEventLeaveTo])
  

  const setOrdinateDate = (e) => {
    setLeaveDataEdit((prev) => ({
      ...prev,
      ordinate_date: e,
    }));
  }

  const setConscriptionDate = (e) => {
    setLeaveDataEdit((prev) => ({
       ...prev,
       conscription_date: e,
     }));
  }

  const setSpouseFromDate = (e) => {
    setLeaveDataEdit((prev) => ({
       ...prev,
       spouse_from_date: e,
     }));
  }

  const setSpouseToDate = (e) => {
    setLeaveDataEdit((prev) => ({
       ...prev,
       spouse_To_date: e,
     }));
  }

  useEffect(() => {
    if (configForm?.form_type !== 2) {
      setHideTimeTypeSelect(true)
    } else {
      if (selectDayCancel?.length > 0 ) {
        setHideTimeTypeSelect(false)
      }
    }
  }, [selectDayCancel])

  const checkCancelTimeType = (cancelDayObject) => {
    return (cancelDayObject?.leave_from_timetype === "1" && cancelDayObject?.leave_to_timetype === "1") ? "1"
      : (cancelDayObject?.leave_from_timetype === "2" && cancelDayObject?.leave_to_timetype === "2") ? "2"
        : "0";
  }

  useEffect(() => {
    if (leaveDataEdit?.form_type === 3) {
      getLeavePerson(leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date);
      getLeaveVacation(leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date);
    }
  }, [leaveDataEdit?.leave_from_date, leaveDataEdit?.leave_to_date])

  const [dataInfo, setDataInfo] = useState({})
  useEffect(() => {
    if (modalState === "view") {
      const url = `${baseURL}/api/users/${leaveDataEdit?.approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setDataInfo(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, [modalState, leaveDataEdit])

  const [flowLoading, setFlowLoading] = useState()
  const [leaveConfigFlowData, setLeaveConfigFlowData] = useState({ thisFlow: [], lastUserApprove: {}, sendToFinal: false })

  useEffect(() => {
    const getLeaveConfigFlow = async () => {
      setFlowLoading(true)
      let flow = await leaveConfigFlow(token, baseURL, userInfo, leaveDataEdit?.leave_type_id)
      setLeaveConfigFlowData(flow)
      setFlowLoading(false)
    }
    leaveDataEdit?.leave_type_id && getLeaveConfigFlow()
  }, [leaveDataEdit?.leave_type_id])
  
  
  const disableSubmit = leaveDataFromSelect.length !== 0 && ( leaveDataEdit?.form_type === 3 ?
                        !leaveDataFromSelect.find(x => (Number(x?.leave_data_id) === Number(leaveDataEdit?.abroad_ref)) || (Number(x?.leave_data_id) === Number(leaveDataEdit?.abroad_ref_2))) :
     !(leaveDataFromSelect.some(
                          i => Number(i.leave_data_id) === Number(leaveDataEdit?.leave_data_id)
                        )))

  return (
    <div>
      <Modal
        centered
        size="xl"
        isOpen={modalLeaveData}
        toggle={async () => {
          setAllDayCancel([]);
          setSelectDayCancel([]);
          setGetEventLeaveTo(null)
          await ToggleModalLeaveData();
        }}
      >
        <ModalHeader toggle={ToggleModalLeaveData}>
          {modalState === "view" ? "รายละเอียดการลา" : "แก้ไขการลา"}
        </ModalHeader>
        <ModalBody>
          {flowLoading ? (
          <FadeIn>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingBar.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              width={180}
              height={180}
            />
          </FadeIn>
        ) : (<><Form
            onSubmit={async (e) => {
              e.preventDefault();
              formValidate?.handleSubmit();
              return false;
            }}
          >
            <FormGroup row className="mt-3">
              <Label className="text-end" xxl={2}>
                เลขที่ใบลา :{" "}
              </Label>
              <Label xxl={10}>{leaveDataEdit?.leave_data_id}</Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                เขียนที่ :
              </Label>
              <Label className="" xxl={4}>
                {leaveDataEdit?.write_place}
              </Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                วันที่เขียน :
              </Label>
              <Label className="" xxl={4}>
                {/* {ConvertDate(leaveDataEdit?.write_date)?.toThaiDateDMY()} */}
                {getDateTime('DD MMM BBBB',leaveDataEdit?.write_date, true)}
              </Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                {configForm?.form_type === 7 && (
                  <span className="me-1 text-danger">*</span>
                )}
                เรื่อง :
              </Label>
              {leaveDataEdit?.form_type === 7 ? (
                <>
                  <Col xl={6}>
                    <Input
                      disabled={modalState === "view" && true}
                      required
                      value={leaveDataEdit?.leave_name}
                      onChange={(e) => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          leave_name: e.target.value,
                        }));
                      }}
                    />
                  </Col>
                  <Col xl={4}></Col>
                </>
              ) : (
                <Label className="" xxl={10}>
                  {configForm?.form_type === 2
                    ? "ขอลาพักผ่อน"
                    : configForm?.form_type === 3
                    ? "ขออนุญาตไปต่างประเทศ"
                    : configForm?.form_type === 4
                    ? "ขอลาอุปสมบท"
                    : configForm?.form_type === 5
                    ? "ขอลาไปประกอบพิธีฮัจญ์"
                    : configForm?.form_type === 6
                    ? "ขอลาเพื่อเข้ารับการเตรียมพล"
                    : configForm?.form_type === 8
                    ? "ขอลาติดตามคู่สมรส"
                    : configForm?.form_type === 9
                    ? "การไปปฏิบัติราชการนอกสำนักงาน ก.พ.ร."
                    : configForm?.form_type === 10
                    ? "การลงเวลาปฏิบัติราชการ"
                    : leaveDataEdit?.leave_name}
                </Label>
              )}

              <Label className="text-end" xxl={2} lg={3} md={3}>
                เรียน :
              </Label>
              <Label className="" xxl={10}>
                {/* {leaveDataEdit?.send_to} */}
                {/* { modalState === "view" ? ('') : */}
                {/* {(userInfo?.leader ? (userInfo?.leader?.position_id < 7 ? `${userInfo?.leader?.user_position_name_dis ?? ''}${userInfo?.leader?.org_name ?? ''}` : `${userInfo?.leader?.user_position_name ?? `${userInfo?.leader?.user_position_name_dis ?? ''}${userInfo?.leader?.org_name ?? ''}`}`) : 'ไม่พบข้อมูล')} */}
                {`${leaderInfo ? (leaderInfo.assign === 1 ? (leaderInfo?.assigned_by_user?.user_name ?? (leaderInfo?.user_name ?? '')) : (leaderInfo?.user_name ?? '')) : ""}`}
              </Label>
              <Label className="text-end" xs={3} xxl={2} lg={3} md={3}>
              </Label>
              <Label xs={9} xxl={10}>{`${leaderInfo?.user_position_name_dis ?? ''}${leaderInfo?.org_name ?? ''}`}</Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                ชื่อ :
              </Label>
              <Label className="" xxl={10}>
                {leaveDataEdit?.user_name}
              </Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                ตำแหน่ง :
              </Label>
              <Label className="" xxl={10} lg={3} md={3}>
                {leaveDataEdit?.user_position_name || "-"}
              </Label>
              <Label className="text-end" xxl={2} lg={3} md={3}>
                สังกัด/กอง :
              </Label>
              <Label className="" xxl={10} lg={3} md={3}>
                {leaveDataEdit?.cont_to_name_1}
              </Label>
            </FormGroup>
            {leaveDataEdit?.form_type === 1 && (
              <FormGroup row>
                <Label className="text-end" xxl={3} lg={3} md={3}>
                  <span className="me-1 text-danger">*</span>ขอลา
                </Label>
                <Col xxl={3} lg={9} md={9}>
                  <Input
                    disabled={modalState === "view" && true}
                    type="select"
                    value={leaveDataEdit?.leave_type_id}
                    onChange={(e) => {
                      setLeaveDataEdit((prev) => ({
                        ...prev,
                        leave_type_id: e.target.value,
                        leave_name: `ขอ${
                          e.target.options[e.target.selectedIndex].text
                        }`,
                      }));
                    }}
                  >
                    {configForm?.leave_type?.map((item) => {
                      return (
                        <option
                          key={item?.leave_type_id}
                          value={item?.leave_type_id}
                        >
                          {item?.leave_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </FormGroup>
            )}
            {configForm?.form_type === 2 && leaveDataEdit.budget_year === CheckBudgetYear() && (
              <>
              <FormGroup row className="text-end">

                <Label xs={11} xxl={11}>
                {"วันลาพักผ่อนสะสมยกมา "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationDayPrev}
                  </strong>{" วัน"}
                </Label>

                <Label xs={11} xxl={11}>
                  {"ใช้ไป "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationUse}
                  </strong>{" วัน"}
                </Label>

                <Label xs={11} xxl={11}>
                  {"วันลาพักผ่อนคงเหลือ "}
                  <strong className="text-primary font-size-16">
                    {vacationRemain?.vacationRemaining}
                  </strong>
                  {" วัน"}
                </Label>

              </FormGroup>
            </>
              // <>
              //   <FormGroup row className="d-flex align-items-center">
              //     <Label className="text-end" xxl={3}>
              //       วันลาพักผ่อนสะสม
              //     </Label>
              //     <Col xxl={3}>
              //       <Input
              //         disabled
              //         type="text"
              //         onChange={(e) => handleInputChange(e, "prevYear")}
              //         value={vacationRemain?.vacationDayPrev ?? "บั๊ก"}
              //         //
              //       />
              //     </Col>
              //     <Label xxl={6}>
              //       มีสิทธิลาพักผ่อนปีนี้อีก{" "}
              //       <strong className="text-primary font-size-16">
              //         {vacationRemain?.vacationRemeaning}
              //       </strong>{" "}
              //       วันทำการ (นับรวมการลาที่ยังไม่อนุมัติ)
              //     </Label>
              //   </FormGroup>
              //   <FormGroup row>
              //     <Label className="text-end" xxl={3}>
              //       รวมเป็น
              //     </Label>
              //     <Col xl={3}>
              //       <Input
              //         disabled
              //         onChange={(e) => handleInputChange(e, "leaveLimit")}
              //         value={vacationRemain?.vacationTotal}
              //         type="text"
              //       />
              //     </Col>
              //   </FormGroup>
              // </>
            )}
            {configForm?.form_type === 3 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    มีความประสงค์จะลา
                  </Label>
                  <Col xl={4}>
                    <Input disabled type="text" value="ไปต่างประเทศ" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>เพื่อไป
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="abroad_for"
                      type="text"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        formValidate?.handleChange(e);
                        handleInputChange(e, "abroad_for");
                      }}
                      value={formValidate?.values.abroad_for}
                      invalid={
                        formValidate?.touched?.abroad_for &&
                        formValidate?.errors?.abroad_for
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.abroad_for &&
                    formValidate?.errors?.abroad_for ? (
                      <FormFeedback type="invalid">
                        {formValidate?.errors?.abroad_for}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ประเทศ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="abroad_country"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        formValidate?.handleChange(e);
                        handleInputChange(e, "abroad_country");
                      }}
                      value={formValidate?.values?.abroad_country}
                      type="text"
                      invalid={
                        formValidate?.touched?.abroad_country &&
                        formValidate?.errors?.abroad_country
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.abroad_country &&
                    formValidate?.errors?.abroad_country ? (
                      <FormFeedback type="invalid">
                        {formValidate?.errors?.abroad_country}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 4 && (
              <>
                <FormGroup row>
                  <Col xl={3}></Col>
                  <Col xl={8}>
                    <Row>
                      <Col xl={1}>
                        <Input
                          disabled={modalState === "view" && true}
                          name="ordinate_ever"
                          type="radio"
                          className="font-size-18 border border-secondary mt-auto"
                          defaultChecked={
                            leaveDataEdit?.ordinate_ever === "0" && true
                          }
                          onChange={(e) =>
                            setLeaveDataEdit((prev) => ({
                              ...prev,
                              ordinate_ever: "0",
                            }))
                          }
                        />
                      </Col>
                      <Col xxl={4}>
                        <Label check>ยังไม่เคยอุปสมบท</Label>
                      </Col>
                      <Col xl={1}>
                        <Input
                          disabled={modalState === "view" && true}
                          name="ordinate_ever"
                          type="radio"
                          className="font-size-18 border border-secondary mt-auto"
                          defaultChecked={
                            leaveDataEdit?.ordinate_ever === "1" && true
                          }
                          onChange={(e) =>
                            setLeaveDataEdit((prev) => ({
                              ...prev,
                              ordinate_ever: "1",
                            }))
                          }
                        />
                      </Col>
                      <Col xxl={4}>
                        <Label check>เคยอุปสมบท</Label>
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>จะอุปสมบท ณ วัด
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="ordinate_temple"
                      type="text"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        formValidate.handleChange(e);
                        handleInputChange(e, "ordinate_temple");
                      }}
                      value={leaveDataEdit?.ordinate_temple}
                      invalid={
                        formValidate?.touched?.ordinate_temple &&
                        formValidate?.errors?.ordinate_temple
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.ordinate_temple &&
                    formValidate?.errors?.ordinate_temple ? (
                      <FormFeedback>
                        {formValidate?.errors?.ordinate_temple}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="ordinate_temple_place"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "ordinate_temple_place");
                        formValidate?.handleChange(e);
                      }}
                      value={leaveDataEdit?.ordinate_temple_place}
                      type="text"
                      invalid={
                        formValidate?.touched?.ordinate_temple_place &&
                        formValidate?.errors?.ordinate_temple_place
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.ordinate_temple_place &&
                    formValidate?.errors?.ordinate_temple_place ? (
                      <FormFeedback>
                        {formValidate?.errors?.ordinate_temple_place}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Label className="text-end" xl={2}>
                    <span className="me-1 text-danger">*</span>วันที่อุปสมบท
                  </Label>
                  <Col xl={3}>
                    {/* <Flatpickr
                      disabled={modalState === "view" && true}
                      name="ordinate_date"
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={leaveDataEdit?.ordinate_date}
                      onChange={(e) => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          ordinate_date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker name ={"ordinate_date"} value={leaveDataEdit?.ordinate_date} setValue={setOrdinateDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>จำพรรษา ณ วัด
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="ordinate_live_temple"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "ordinate_live_temple");
                        formValidate.handleChange(e);
                      }}
                      value={leaveDataEdit?.ordinate_live_temple}
                      type="text"
                      invalid={
                        formValidate?.touched?.ordinate_live_temple &&
                        formValidate?.errors?.ordinate_live_temple
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.ordinate_live_temple &&
                    formValidate?.errors?.ordinate_live_temple ? (
                      <FormFeedback>
                        {formValidate?.errors?.ordinate_live_temple}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งอยู่ ณ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="ordinate_live_place"
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "ordinate_live_place");
                        formValidate?.handleChange(e);
                      }}
                      value={formValidate?.values?.ordinate_live_place}
                      type="text"
                      invalid={
                        formValidate?.touched?.ordinate_live_place &&
                        formValidate?.errors?.ordinate_live_place
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.ordinate_live_place &&
                    formValidate?.errors?.ordinate_live_place ? (
                      <FormFeedback>
                        {formValidate?.errors?.ordinate_live_place}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 5 && (
              <FormGroup row>
                <Col xl={3}></Col>
                <Col xl={8}>
                  <Row>
                    <Col xl={1}>
                      <Input
                        disabled={modalState === "view" && true}
                        required
                        name="hujj_ever"
                        defaultChecked={
                          leaveDataEdit?.hujj_ever === "0" && true
                        }
                        className="font-size-18 border border-secondary mt-auto"
                        type="radio"
                        onChange={(e) => {
                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            hujj_ever: "0",
                          }));
                        }}
                      />
                    </Col>
                    <Col xl={5}>
                      <Label check>ยังไม่เคยไปประกอบพิธีฮัจญ์ </Label>
                    </Col>
                    <Col xl={1}>
                      <Input
                        disabled={modalState === "view" && true}
                        name="hujj_ever"
                        type="radio"
                        defaultChecked={
                          leaveDataEdit?.hujj_ever === "1" && true
                        }
                        className="font-size-18 border border-secondary mt-auto"
                        onChange={(e) =>
                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            hujj_ever: "1",
                          }))
                        }
                      />
                    </Col>
                    <Col xl={5}>
                      <Label check>เคยไปประกอบพิธีฮัจญ์</Label>
                    </Col>
                  </Row>
                </Col>
              </FormGroup>
            )}
            {configForm?.form_type === 6 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>
                    ได้รับหมายเรียกของ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="conscription_from"
                      value={leaveDataEdit?.conscription_from}
                      type="text"
                      onBlur={formValidate.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "conscription_from");
                        formValidate.handleChange(e);
                      }}
                      invalid={
                        formValidate.touched.conscription_for &&
                        formValidate.errors.conscription_from
                          ? true
                          : false
                      }
                    />
                    {formValidate.touched.conscription_for &&
                    formValidate.errors.conscription_from ? (
                      <FormFeedback>
                        {formValidate.errors.conscription_for}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ที่
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="conscription_place"
                      type="text"
                      value={leaveDataEdit?.conscription_place}
                      onBlur={formValidate.handleBlur}
                      onChange={(e) => {
                        formValidate.handleChange(e);
                        handleInputChange(e, "conscription_place");
                      }}
                      invalid={
                        formValidate.touched.conscription_place &&
                        formValidate.errors.conscription_place
                          ? true
                          : false
                      }
                    />
                    {formValidate.touched.conscription_place &&
                    formValidate.errors.conscription_place ? (
                      <FormFeedback>
                        {formValidate.errors.conscription_place}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Label className="text-end" xxl={2}>
                    <span className="me-1 text-danger">*</span>ลงวันที่
                  </Label>
                  <Col xl={3}>
                    {/* <Flatpickr
                      required
                      disabled={modalState === "view" && true}
                      name="conscription_date"
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        // altInput: true,
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={leaveDataEdit?.conscription_date}
                      onChange={(e) => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          conscription_date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker name ={"conscription_date"} value={leaveDataEdit?.conscription_date} setValue={setConscriptionDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ให้เข้ารับการ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="conscription_for"
                      type="text"
                      value={leaveDataEdit?.conscription_for}
                      onBlur={formValidate.handleBlur}
                      onChange={(e) => {
                        formValidate.handleChange(e);
                        handleInputChange(e, "conscription_for");
                      }}
                      invalid={
                        formValidate.touched.conscription_for &&
                        formValidate.errors.conscription_for
                          ? true
                          : false
                      }
                    />
                    {formValidate.touched.conscription_for &&
                    formValidate.errors.conscription_for ? (
                      <FormFeedback>
                        {formValidate.errors.conscription_for}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ที่
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="conscription_to_place"
                      value={leaveDataEdit?.conscription_to_place}
                      type="text"
                      onBlur={formValidate.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "conscription_to_place");
                        formValidate.handleChange(e);
                      }}
                      invalid={
                        formValidate.touched.conscription_to_place &&
                        formValidate.errors.conscription_to_place
                          ? true
                          : false
                      }
                    />
                    {formValidate.touched.conscription_to_place &&
                    formValidate.errors.conscription_to_place ? (
                      <FormFeedback>
                        {formValidate.errors.conscription_to_place}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 7 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xs={3} xxl={3}>
                    มีความประสงค์
                  </Label>
                  <Col xs={9} xl={8}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="abroad_for"
                      type="textarea"
                      style={{ height: "75px" }}
                      value={leaveDataEdit?.abroad_for}
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        formValidate?.handleChange(e);
                        handleInputChange(e, "abroad_for")
                      }}
                      invalid={
                        formValidate?.touched.abroad_for &&
                        formValidate?.errors.abroad_for
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.abroad_for &&
                    formValidate?.errors?.abroad_for ? (
                      <FormFeedback>
                        {formValidate?.errors?.abroad_for}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ณ ประเทศ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="abroad_country"
                      type="text"
                      value={leaveDataEdit?.abroad_country}
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        formValidate?.handleChange(e);
                        handleInputChange(e, "abroad_country");
                      }}
                      invalid={
                        formValidate?.touched.abroad_country &&
                        formValidate?.errors.abroad_country
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.abroad_country &&
                    formValidate?.errors?.abroad_country ? (
                      <FormFeedback>
                        {formValidate?.errors?.abroad_country}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    ด้วยทุน(ถ้ามี)
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      type="text"
                      value={leaveDataEdit?.training_fund_from}
                      onChange={(e) =>
                        handleInputChange(e, "training_fund_from")
                      }
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 8 && (
              <FormGroup row>
                <Label className="text-end" xxl={3}>
                  <span className="me-1 text-danger">*</span>มีความประสงค์จะลา
                </Label>
                <Col xl={4}>
                  <Input
                    type="text"
                    readOnly
                    disabled
                    value="ติดตามคู่สมรส"
                    onChange={(e) => handleInputChange(e, "leaveReq")}
                  />
                </Col>
              </FormGroup>
            )}
            {configForm?.form_type === 9 && (
              <FormGroup row>
                <Label className="text-end" xxl={3}>
                  <span className="me-1 text-danger">*</span>สถานที่
                </Label>
                <Col xl={8}>
                  <Input
                    disabled={modalState === "view" && true}
                    name="outside_place"
                    type="text"
                    value={leaveDataEdit?.outside_place}
                    onBlur={formValidate?.handleBlur}
                    onChange={(e) => {
                      handleInputChange(e, "outside_place");
                      formValidate.handleChange(e);
                    }}
                    invalid={
                      formValidate?.touched?.outside_place &&
                      formValidate?.errors?.outside_place
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.outside_place &&
                  formValidate?.errors?.outside_place ? (
                    <FormFeedback>
                      {formValidate?.errors?.outside_place}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            )}
            {configForm?.form_type === 11 && (
              <FormGroup row>
                <Label className="text-end" xxl={3}>
                  มีความประสงค์จะลา
                </Label>
                <Col xxl={8}>
                  <Input
                    disabled={modalState === "view" && true}
                    type="select"
                    value={leaveDataEdit?.leave_type_id}
                    onChange={(e) => {
                      setLeaveDataEdit((prev) => ({
                        ...prev,
                        leave_type_id: e.target.value,
                        leave_name: `ขอ${
                          e.target.options[e.target.selectedIndex].text
                        }`,
                      }));
                    }}
                  >
                    {configForm?.leave_type?.map((item, idx) => {
                      return (
                        <option
                          key={item?.leave_type_id}
                          value={item?.leave_type_id}
                        >
                          {item?.leave_name}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              </FormGroup>
            )}
            {configForm?.form_type === 1 || configForm?.form_type === 11 ? (
              <FormGroup row>
                <Label className="text-end" xxl={3} lg={3} md={3}>
                  <span className="me-1 text-danger">*</span>เนื่องจาก
                </Label>
                <Col xxl={8} lg={9} md={9}>
                  <Input
                    disabled={modalState === "view" && true}
                    className="form-control"
                    type="textarea"
                    name="leave_reason"
                    onChange={(e) => {
                      formValidate?.handleChange(e);
                      handleInputChange(e, "leave_reason");
                    }}
                    onBlur={formValidate?.handleBlur}
                    value={leaveDataEdit?.leave_reason}
                    style={{ height: "75px" }}
                    invalid={
                      formValidate?.touched?.leave_reason &&
                      formValidate?.errors?.leave_reason
                        ? true
                        : false
                    }
                  />
                  {formValidate?.touched?.leave_reason &&
                  formValidate?.errors?.leave_reason ? (
                    <FormFeedback>
                      {formValidate?.errors?.leave_reason}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            ) : null}

            <FormGroup row>
              <Label
                className="text-end mt-2"
                xxl={configForm?.form_type === 10 ? 4 : 3}
                lg={3}
                md={3}
              >
                <span className="me-1 text-danger">*</span>
                {configForm?.form_type === 10
                  ? "ไม่สามารถลงปฏิบัติราชการเมื่อวันที่"
                  : "ตั้งแต่วันที่"}
              </Label>
              <Col xxl={3} lg={9} md={9} className="mt-2">
              {/* {configForm?.form_type === 2 ? 
                <Flatpickr
                  disabled={modalState === "view" && true}
                  className="form-control d-block"
                  placeholder="วัน/เดือน/ปี"
                  options={{
                    // altInput: true,
                    dateFormat: "d-m-Y",
                    ariaDateFormat: "F j, Y",
                    locale: "th",
                  }}
                  value={leaveDataEdit?.leave_from_date}
                  onChange={(e) => {
                    if (leaveDataEdit?.leave_to_date !== null) {
                      const leaveDays = calculateLeaveDays(
                        e[0],
                        leaveDataEdit?.leave_from_timetype,
                        e[0],
                        leaveDataEdit?.leave_to_timetype
                      );
                      setLeaveDataEdit((prev) => ({
                        ...prev,
                        leave_from_date: e[0],
                        leave_to_date: e[0],
                        leave_days: leaveDays,
                      }));
                    }
                    if (configForm?.form_type === 2) {
                      getAllDayCancel(e[0], e[0]);
                    }
                    setLeaveDataEdit((prev) => ({
                      ...prev,
                      leave_from_date: e[0],
                      leave_to_date: e[0],
                    }));
                  }}
                />
               :  */}
               <NewThaiDatePicker name ={"leave_from_date"} value={leaveDataEdit?.leave_from_date} setValue={setLeaveFromDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                {/* } */}
                {/* <Flatpickr
                disabled={modalState==="view" && true}
                className="form-control d-block"
                placeholder="วัน/เดือน/ปี"
                options={{
                  dateFormat: "d-m-Y",
                  ariaDateFormat: "F j, Y",
                  locale: "th",
                  minDate: "today",
                }}
                value={leaveDataEdit?.leave_from_date}
                onChange={(e) => {
                  if (leaveDataEdit?.leave_to_date !== null) {
                    const leaveDays = calculateLeaveDays(
                      e[0],
                      leaveDataEdit?.leave_from_timetype,
                      e[0],
                      leaveDataEdit?.leave_to_timetype
                    );
                    setLeaveDataEdit((prev) => ({
                      ...prev,
                      leave_from_date: e[0],
                      leave_to_date: e[0],
                      leave_days: leaveDays,
                    }));
                  }
                  setLeaveDataEdit((prev) => ({
                    ...prev,
                    leave_from_date: e[0],
                    leave_to_date: e[0],
                  }));
                }}
              /> */}
              </Col>
              {configForm?.form_type !== 4 && configForm?.form_type !== 8 && configForm?.form_type !== 10 && hideTimeTypeSelect === true ? (
                <>
                  <Label
                    className="mt-2"
                    style={{ textAlign: "end" }}
                    xxl={2}
                    lg={3}
                    md={3}
                  >
                    ช่วงเวลา
                  </Label>
                  <Col xl={3} lg={9} md={9} className="mt-2">
                    <Input
                      disabled={modalState === "view" && true}
                      type="select"
                      value={leaveDataEdit?.leave_from_timetype}
                      onChange={(e) => {
                        if (
                          leaveDataEdit?.leave_from_date &&
                          leaveDataEdit?.leave_to_date
                        ) {
                          const leaveDays = calculateLeaveDays(
                            new Date(
                              new Date(leaveDataEdit?.leave_from_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),

                            e?.target?.value,
                            new Date(
                              new Date(leaveDataEdit?.leave_to_date).setHours(
                                0,
                                0,
                                0,
                                0
                              )
                            ),
                            leaveDataEdit?.leave_to_timetype
                          );

                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            leave_from_timetype: e?.target?.value,
                            leave_days: leaveDays,
                          }));
                        }
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          leave_from_timetype: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="1">9.30</option>
                      <option value="2">13.00</option>
                    </Input>
                  </Col>
                </>
              ) : null}
            </FormGroup>
            {configForm?.form_type !== 10 &&
              <FormGroup row>
                <Label
                  className="text-end mt-2"
                  xxl={configForm?.form_type === 10 ? 4 : 3}
                  lg={3}
                  md={3}
                >
                  <span className="me-1 text-danger">*</span>ถึงวันที่
                </Label>
                <Col xl={3} lg={9} md={9} className="mt-2">
                {/* {configForm?.form_type === 2 ? 
                  <Flatpickr
                    disabled={modalState === "view" && true}
                    className="form-control d-block"
                    placeholder="วัน/เดือน/ปี"
                    options={{
                      // altInput: true,
                      dateFormat: "d-m-Y",
                      ariaDateFormat: "F j, Y",
                      locale: "th",
                    }}
                    value={leaveDataEdit?.leave_to_date}
                    onChange={(e) => {
                      if (leaveDataEdit?.leave_from_date !== null) {
                        const leaveDays = calculateLeaveDays(
                          new Date(
                            new Date(leaveDataEdit?.leave_from_date).setHours(
                              0,
                              0,
                              0,
                              0
                            )
                          ),
                          leaveDataEdit?.leave_from_timetype,
                          e[0],
                          leaveDataEdit?.leave_to_timetype
                        );
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          leave_to_date: e[0],
                          leave_days: leaveDays,
                        }));
                      }
                      if (configForm?.form_type === 2) {
                        getAllDayCancel(
                          new Date(leaveDataEdit?.leave_from_date),
                          e[0]
                        );
                      }
                      setLeaveDataEdit((prev) => ({
                        ...prev,
                        leave_to_date: e[0],
                      }));
                    }}
                  /> : */}
                  <NewThaiDatePicker name ={"leave_to_date"} value={leaveDataEdit?.leave_to_date} minDate = {leaveDataEdit?.leave_from_date} setValue={setLeaveToDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                  {/* } */}
                </Col>
                {configForm?.form_type !== 4 && configForm?.form_type !== 8 && hideTimeTypeSelect === true ? (
                  <>
                    <Label
                      style={{ textAlign: "end" }}
                      xl={2}
                      lg={3}
                      md={3}
                      className="mt-2"
                    >
                      ช่วงเวลา
                    </Label>
                    <Col xl={3} lg={9} md={9} className="mt-2">
                      <Input
                        disabled={modalState === "view" && true}
                        type="select"
                        value={leaveDataEdit?.leave_to_timetype}
                        onChange={(e) => {
                          if (
                            leaveDataEdit?.leave_from_date &&
                            leaveDataEdit?.leave_to_date
                          ) {
                            const leaveDays = calculateLeaveDays(
                              new Date(
                                new Date(leaveDataEdit?.leave_from_date).setHours(
                                  0,
                                  0,
                                  0,
                                  0
                                )
                              ),
                              leaveDataEdit?.leave_from_timetype,
                              new Date(
                                new Date(leaveDataEdit?.leave_to_date).setHours(
                                  0,
                                  0,
                                  0,
                                  0
                                )
                              ),
                              e.target.value
                            );

                            setLeaveDataEdit((prev) => ({
                              ...prev,
                              leave_to_timetype: e?.target?.value,
                              leave_days: leaveDays,
                            }));
                          }
                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            leave_to_timetype: e?.target?.value,
                          }));
                        }}
                      >
                        <option value="1">12.00</option>
                        <option value="2">17.30</option>
                      </Input>
                    </Col>
                  </>
                ) : null}
              </FormGroup>
            }
            {configForm?.form_type !== 3 && leaveDataFromSelect.length !== 0 ? (
            <FormGroup row>
              <Label className="text-end text-danger" xxl={3} lg={3} md={3}>
               คุณมีการลาในช่วงวันที่เลือก
              </Label>
              <Col xxl={8} lg={9} md={9}>
                {leaveDataFromSelect?.map((item, idx) => {
                return (
                  <Input
                    disabled key={idx}
                    style={{ textAlign: "start" }} 
                    className="text-danger mb-1"
                    value={
                      `${item?.leave_name} วันที่ ${ConvertDate(item?.leave_from_date).toOnlyDateTHYear()} เวลา ${item?.leave_from_timetype === "1" ? "9.30" : "13.00"} น. ถึง ${ConvertDate(item?.leave_to_date).toOnlyDateTHYear()} เวลา ${item?.leave_to_timetype === "1" ? "12.00" : "17.30"} น.`
                    }
                  />
                );
                })}
              </Col>
            </FormGroup>
          ) : null}
            {configForm?.form_type === 2 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    ยกเว้นวันที่
                  </Label>
                  <Col xxl={3}>
                    <Input
                      disabled={modalState === "view" && true}
                      type="select"
                      value=""
                      onChange={(e) => {
                        const selectedDate = new Date(e.target.value);
                        if (
                          e.target.value !== "" &&
                          selectDayCancel?.length === 0
                        ) {
                          let newValue = {
                            leave_data_id: leaveDataEdit?.leave_data_id,
                            date_cancel: selectedDate,
                            leave_from_timetype: "1",
                            leave_to_timetype: "2",
                          };

                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            leave_days: prev.leave_days - 1,
                          }));
                          setSelectDayCancel((prev) => [...prev, newValue]);
                          setAllDayCancel((prev) =>
                            prev.filter(
                              (item) =>
                                new Date(
                                  item?.date_cancel
                                )?.toLocaleDateString() !==
                                selectedDate?.toLocaleDateString()
                            )
                          );
                        } else if (
                          !selectDayCancel?.find(
                            (i) =>
                              new Date(i?.date_cancel)?.toLocaleDateString() ===
                              selectedDate.toLocaleDateString()
                          )
                        ) {
                          let check = selectDayCancel?.find(
                            (i) =>
                              new Date(i?.date_cancel)?.toLocaleDateString() ===
                              selectedDate.toLocaleDateString()
                          );

                          let newValue = {
                            leave_data_id: leaveDataEdit?.leave_data_id,
                            date_cancel: selectedDate,
                            leave_from_timetype: "1",
                            leave_to_timetype: "2",
                          };

                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            leave_days: prev.leave_days - 1,
                          }));
                          setSelectDayCancel((prev) => [...prev, newValue]);
                          setAllDayCancel((prev) =>
                            prev.filter(
                              (item) =>
                                new Date(
                                  item?.date_cancel
                                )?.toLocaleDateString() !==
                                selectedDate?.toLocaleDateString()
                            )
                          );
                        }
                      }}
                    >
                      <option value="">เลือกวันที่ต้องการยกเลิก</option>
                      {allDayCancel &&
                        allDayCancel?.map((item, idx) => {
                          // let checkItem = CheckCancelDayIsweekEndOrThaiPublic(item?.date)
                          let checkAllWithSelectDay = selectDayCancel?.find(
                            (a) =>
                              new Date(a?.date_cancel)?.toLocaleDateString() ===
                              new Date(item?.date_cancel)?.toLocaleDateString()
                          );
                          let showDate = ConvertDate(
                            new Date(item?.date_cancel)
                          )?.toThaiDateDMY();
                          if (!checkAllWithSelectDay) {
                            return (
                              <option
                                key={idx}
                                value={new Date(item?.date_cancel)}
                              >
                                {showDate}
                              </option>
                            );
                          } else {
                            return null;
                          }
                        })}
                    </Input>
                  </Col>
                </FormGroup>
                {configForm?.form_type === 2 && leaveDataEdit?.leave_status === "A" && selectDayCancel2?.length !== 0 ? (
                <FormGroup row className="d-flex align-items-center">
                  {selectDayCancel2?.map((item, idx) => {
                    const DateItem = new Date(item?.date_cancel);
                    let showDate = ConvertDate(
                      item?.date_cancel
                    )?.toThaiDateDMY();
                    return (
                      <React.Fragment key={idx}>
                        <Label className="text-end" xxl={4}>
                          <i
                            style={{
                              cursor: "default",
                            }}
                            className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                          ></i>
                          {showDate}
                        </Label>
                        <Label style={{ textAlign: "end" }} xl={2} lg={3}>
                          ช่วงเวลา
                        </Label>
                        <Col xl={3} lg={9} md={9} className="mt-2">
                          <Input disabled type="select">
                            <option value="0">เต็มวัน</option>
                            <option value="1">ครึ่งวันเช้า</option>
                            <option value="2">ครึ่งวันบ่าย</option>
                          </Input>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </FormGroup>
              ) : null}
                {selectDayCancel?.length === 0 ? null : (
                  <FormGroup row className="d-flex align-items-center">
                    {selectDayCancel?.map((item, idx) => {
                      const DateItem = new Date(item?.date_cancel);
                      let showDate = ConvertDate(
                        item?.date_cancel
                      )?.toThaiDateDMY();

                      // let leaveDaysSum = leaveDataEdit?.leave_days;
                      return (
                        <React.Fragment key={idx}>
                          <Label className="text-end" xxl={4}>
                            <i
                              style={{
                                cursor:
                                  modalState === "view" ? "default" : "pointer",
                              }}
                              onClick={() => {
                                if (modalState === "edit") {
                                  const selectedDate = new Date(
                                    item?.date_cancel
                                  );
                                  let newValue = {
                                    date_cancel: selectedDate,
                                  };
                                  if (
                                    item?.leave_from_timetype === "1" &&
                                    item?.leave_to_timetype === "1"
                                  ) {
                                    setLeaveDataEdit((prev) => ({
                                      ...prev,
                                      leave_days: prev?.leave_days + 0.5,
                                    }));
                                  }
                                  if (
                                    item?.leave_from_timetype === "2" &&
                                    item?.leave_to_timetype === "2"
                                  ) {
                                    setLeaveDataEdit((prev) => ({
                                      ...prev,
                                      leave_days: prev?.leave_days + 0.5,
                                    }));
                                  }
                                  if (
                                    item?.leave_from_timetype === "1" &&
                                    item?.leave_to_timetype === "2"
                                  ) {
                                    setLeaveDataEdit((prev) => ({
                                      ...prev,
                                      leave_days: prev?.leave_days + 1,
                                    }));
                                  }
                                  setSelectDayCancel((prev) =>
                                    prev.filter(
                                      (item) =>
                                        new Date(
                                          item?.date_cancel
                                        )?.toLocaleDateString() !==
                                        selectedDate.toLocaleDateString()
                                    )
                                  );
                                  setAllDayCancel((prev) => [
                                    ...prev,
                                    newValue,
                                  ]);
                                }
                              }}
                              className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                            ></i>
                            {showDate}
                          </Label>
                          <Label style={{ textAlign: "end" }} xl={2} lg={3}>
                            ช่วงเวลา
                          </Label>
                          <Col xl={3} lg={9} md={9} className="mt-2">
                            <Input
                              disabled={modalState === "view" && true}
                              value={checkCancelTimeType(item)}
                              type="select"
                              onChange={(e) => {
                                const selectedTime = e.target.value;
                                const sumDay = calculateCancelLeaveDay(
                                  item?.leave_from_timetype,
                                  item?.leave_to_timetype,
                                  leaveDataEdit?.leave_days,
                                  e.target.value,
                                  DateItem
                                );
                                setLeaveDataEdit((prev) => ({
                                  ...prev,
                                  leave_days: sumDay,
                                }));
                              }}
                            >
                              {
                              //timetype 1,1 ครึ่งวันเช้า 2,2 ครึ่งวันบ่าย
                              }
                              <option value="0">เต็มวัน</option>
                              <option value="1">ครึ่งวันเช้า</option> 
                              <option value="2">ครึ่งวันบ่าย</option>
                            </Input>
                          </Col>
                        </React.Fragment>
                      );
                    })}
                  </FormGroup>
                )}
                {leaveDataEdit?.leave_status === "7" || leaveDataEdit?.leave_status === "B" ? (
                <>
                <FormGroup row>
                <Label className="text-end" xxl={4}>
                  วันที่เปลี่ยนแปลงหลังการขอยกเลิก
                </Label>
              </FormGroup>
              {selectDayCancel2?.length === 0 ? null : (
                <FormGroup row className="d-flex align-items-center">
                  {selectDayCancel2?.map((item, idx) => {
                    const DateItem = new Date(item?.date_cancel);
                    let showDate = ConvertDate(
                      item?.date_cancel
                    )?.toThaiDateDMY();
                    return (
                      <React.Fragment key={idx}>
                        <Label className="text-end" xxl={4}>
                          <i
                            style={{
                              cursor: "default",
                            }}
                            className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                          ></i>
                          {showDate}
                        </Label>
                        <Label style={{ textAlign: "end" }} xl={2} lg={3}>
                          ช่วงเวลา
                        </Label>
                        <Col xl={3} lg={9} md={9} className="mt-2">
                          <Input disabled type="select">
                            <option value="0">เต็มวัน</option>
                            <option value="1">ครึ่งวันเช้า</option>
                            <option value="2">ครึ่งวันบ่าย</option>
                          </Input>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </FormGroup>
              )}
              </>
              ) : null}
              </>
            )}
            <FormGroup row style={{ display: "flex", alignItems: "center" }}>
              <Label className="text-end" xxl={3} lg={3} md={3}>
                รวม
              </Label>
              <Col xl={3} lg={9} md={9}>
                {/* <Input
                  disabled
                  type="text"
                  value={leaveDataEdit?.leave_days}
                  readOnly
                /> */}
                <Input disabled type="text" value={`${leaveDataEdit?.leave_days ?? ''} ${leaveDataEdit?.leave_status === "7" || leaveDataEdit?.leave_status === "B" ? `(หากมีการอนุมัติยกเลิกจะมีวันลารวม ${leaveDataEdit?.change_days ?? ''} วัน)` : ""}`} />
              </Col>
            </FormGroup>
            {configForm?.form_type !== 3 &&
              configForm?.form_type !== 4 &&
              configForm?.form_type !== 5 &&
              configForm?.form_type !== 6 &&
              configForm?.form_type !== 7 &&
              configForm?.form_type !== 8 &&
              configForm?.form_type !== 9 &&
              configForm?.form_type !== 10 &&
              configForm?.form_type !== 11 && (
                <FormGroup row>
                  <Label className="text-end" xxl={3} lg={3} md={3}>
                    <span className="me-1 text-danger">*</span>สถานที่ติดต่อ
                  </Label>
                  <Col xxl={8} lg={9} md={9}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="contact_address"
                      className="form-control"
                      onBlur={formValidate.handleBlur}
                      onChange={(e) => {
                        formValidate.handleChange(e);
                        handleInputChange(e, "contact_address");
                      }}
                      value={leaveDataEdit?.contact_address}
                      style={{ height: "75px" }}
                      type="textarea"
                      invalid={
                        formValidate?.touched.contact_address &&
                        formValidate?.errors.contact_address
                          ? true
                          : false
                      }
                    />
                    {formValidate.touched.contact_address &&
                    formValidate.errors.contact_address ? (
                      <FormFeedback>
                        {formValidate.errors.contact_address}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
              )}
            {configForm?.form_type === 3 && (
              <>
                <FormGroup
                  row
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Label className="text-end" xl={3}>
                    ได้ลากิจวันที่
                  </Label>
                  <Label xl={6}>กรุณากรอก ลากิจ หรือ ลาพักผ่อน ก่อน</Label>
                </FormGroup>
                <FormGroup row>
                  <Col xl={3}></Col>
                  <Col xl={3}>
                    <Input
                      readOnly
                      type="select"
                      value={leaveDataEdit?.abroad_ref_2}
                      onChange={(e) => handleInputChange(e, "abroad_ref_2")}
                    >
                      {leavePerson?.length === 0 ? (
                        <option>คุณไม่มีประวัติการลากิจ</option>
                      ) : (
                        <>
                          <option value="">กรุณาเลือกวันลากิจ</option>
                          {leavePerson?.map((item) => {
                            return (
                              <option value={item?.leave_data_id}>
                                {item?.leave_name}
                                &nbsp;วันที่{" "}
                                {convertDate(item?.leave_from_date).toDate()}
                                &nbsp;
                                {convertDate(item?.leave_from_date).toMonth()}
                                &nbsp;
                                {convertDate(item?.leave_from_date).toYear()}
                                &nbsp;ถึง{" "}
                                {convertDate(item?.leave_to_date).toDate()}
                                &nbsp;
                                {convertDate(item?.leave_to_date).toMonth()}
                                &nbsp;
                                {convertDate(item?.leave_to_date).toYear()}
                                &nbsp;เป็นเวลา {item?.leave_days} วัน
                              </option>
                            );
                          })}
                        </>
                      )}
                    </Input>
                  </Col>
                  <Label className="text-end" xl={2}>
                    ได้ลาพักผ่อนวันที่
                  </Label>
                  <Col xl={3}>
                    <Input
                      readOnly
                      type="select"
                      value={leaveDataEdit?.abroad_ref}
                      onChange={(e) => handleInputChange(e, "abroad_ref")}
                    >
                      {leaveVacation?.length === 0 ? (
                        <option>คุณไม่มีประวัติการลาพักผ่อน</option>
                      ) : (
                        <>
                          <option value="">กรุณาเลือกวันลาพักผ่อน</option>
                          {leaveVacation?.map((item) => {
                            return (
                              <option value={item.leave_data_id}>
                                {item?.leave_name}
                                &nbsp;วันที่{" "}
                                {convertDate(item?.leave_from_date).toDate()}
                                &nbsp;
                                {convertDate(item?.leave_from_date).toMonth()}
                                &nbsp;
                                {convertDate(item?.leave_from_date).toYear()}
                                &nbsp;ถึง{" "}
                                {convertDate(item?.leave_to_date).toDate()}
                                &nbsp;
                                {convertDate(item?.leave_to_date).toMonth()}
                                &nbsp;
                                {convertDate(item?.leave_to_date).toYear()}
                                &nbsp;เป็นเวลา {item?.leave_days} วัน
                              </option>
                            );
                          })}
                        </>
                      )}
                    </Input>
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 8 && (
              <>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ชื่อคู่สมรส
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="spouse_name"
                      type="text"
                      value={leaveDataEdit?.spouse_name}
                      onChange={(e) => {
                        formValidate.handleChange(e);
                        handleInputChange(e, "spouse_name");
                      }}
                      onBlur={formValidate?.handleBlur}
                      invalid={
                        formValidate?.touched?.spouse_name &&
                        formValidate?.errors?.spouse_name
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.spouse_name &&
                    formValidate?.errors?.spouse_name ? (
                      <FormFeedback>
                        {formValidate?.errors?.spouse_name}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    ตำแหน่งคู่สมรส
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      type="text"
                      value={leaveDataEdit?.spouse_position}
                      onChange={(e) => handleInputChange(e, "spouse_position")}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    สังกัดคู่สมรส
                  </Label>
                  <Col xl={4}>
                    <Input
                      type="text"
                      disabled={modalState === "view" && true}
                      value={leaveDataEdit?.spouse_department}
                      onChange={(e) =>
                        handleInputChange(e, "spouse_department")
                      }
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ปฏิบัติงาน ณ
                    ประเทศ
                  </Label>
                  <Col xl={4}>
                    <Input
                      disabled={modalState === "view" && true}
                      name="spouse_country"
                      type="text"
                      value={leaveDataEdit?.spouse_country}
                      onBlur={formValidate?.handleBlur}
                      onChange={(e) => {
                        handleInputChange(e, "spouse_country");
                        formValidate?.handleChange(e);
                      }}
                      invalid={
                        formValidate?.touched?.spouse_country &&
                        formValidate?.errors?.spouse_country
                          ? true
                          : false
                      }
                    />
                    {formValidate?.touched?.spouse_country &&
                    formValidate?.errors?.spouse_country ? (
                      <FormFeedback>
                        {formValidate?.errors?.spouse_country}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ตั้งแต่วันที่
                  </Label>
                  <Col xxl={4}>
                    {/* <Flatpickr
                      disabled={modalState === "view" && true}
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        // altInput: true,
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={leaveDataEdit?.spouse_from_date}
                      onChange={(e) => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          spouse_from_date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker name ={"spouse_from_date"} value={leaveDataEdit?.spouse_from_date} minDate = {leaveDataEdit?.spouse_from_date} setValue={setSpouseFromDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="text-end" xxl={3}>
                    <span className="me-1 text-danger">*</span>ถึงวันที่
                  </Label>
                  <Col xxl={4}>
                    {/* <Flatpickr
                      disabled={modalState === "view" && true}
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      options={{
                        // altInput: true,
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      value={leaveDataEdit?.spouse_to_date}
                      onChange={(e) => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          spouse_to_date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker name ={"spouse_to_date"} value={leaveDataEdit?.spouse_to_date} minDate = {leaveDataEdit?.spouse_to_date} setValue={setSpouseToDate} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                </FormGroup>
              </>
            )}
            {configForm?.form_type === 10 && (
              <FormGroup row>
                <Label className="text-end" xxl={3}>
                  <span className="me-1 text-danger">*</span>เหตุผล
                </Label>
                <Col xl={8}>
                  <Input
                    disabled={modalState === "view" && true}
                    name="practice_reason"
                    type="text"
                    value={leaveDataEdit?.practice_reason}
                    onChange={(e) => {
                      formValidate.handleChange(e);
                      handleInputChange(e, "practice_reason");
                    }}
                    onBlur={formValidate.handleBlur}
                    invalid={
                      formValidate.touched.practice_reason &&
                      formValidate.errors.practice_reason
                        ? true
                        : false
                    }
                  />
                  {formValidate.touched.practice_reason &&
                  formValidate.errors.practice_reason ? (
                    <FormFeedback>
                      {formValidate.errors.practice_reason}
                    </FormFeedback>
                  ) : null}
                </Col>
              </FormGroup>
            )}
            <FormGroup row>
              <Label className="text-end" xxl={3} lg={3} md={3}>
                หมายเหตุ
              </Label>
              <Col xxl={8} lg={9} md={9}>
                <Input
                  disabled={modalState === "view" && true}
                  onChange={(e) => handleInputChange(e, "note")}
                  value={leaveDataEdit?.note || ""}
                  style={{ height: "75px" }}
                  type="textarea"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label className="text-end" xxl={3} lg={3} md={4}>
                แนบเอกสาร{" "}
              </Label>
              <Col xxl={8} lg={9} md={8}>
                {modalState === "view" && <Row className="d-flex align-items-center">
                  <Col>
                    <Button className="btn btn-info w-75" disabled={!(leaveDataEdit?.file_data)} onClick={() => {
                        window.open(`${baseURL}${leaveDataEdit?.file_data.split('./public')[1]}`, "_blank", "noopener,noreferrer");
                      }}>
                        {leaveDataEdit?.file_data ? (leaveDataEdit?.file_data.split('/file/')[1]) : "ไม่มีไฟล์แนบ"}
                    </Button>
                  </Col>
                </Row>}
                {modalState === "edit" && <>
                {leaveDataEdit?.file_data && typeof leaveDataEdit?.file_data === "string" ? <Row className="d-flex align-items-center mb-2">
                  <Col>
                    <Button className="btn btn-info w-100" disabled={!(leaveDataEdit?.file_data)} onClick={() => {
                        window.open(`${baseURL}${leaveDataEdit?.file_data.split('./public')[1]}`, "_blank", "noopener,noreferrer");
                      }}>
                        {leaveDataEdit?.file_data ? (leaveDataEdit?.file_data.split('/file/')[1]) : "ไม่มีไฟล์แนบ"}
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      onClick={() => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          file_data: null,
                        }));
                      }}
                      className="btn btn-danger"
                    >
                      <i className="fa-solid fa-trash"></i>
                    </Button>
                  </Col>
                </Row> : <Row className="d-flex align-items-center">
                   <Col>
                    <Input
                      disabled={modalState === "view" && true}
                      key={fileKey}
                      // ref={fileInputRef}
                      type="file"
                      onChange={(e) => {
                        setLeaveDataEdit((prevData) => ({
                          ...prevData,
                          file_data: e?.target?.files[0],
                        }));
                      }}
                    />
                  </Col>
                  <Col>
                    <Button
                      onClick={() => {
                        setLeaveDataEdit((prev) => ({
                          ...prev,
                          file_data: null,
                        }));
                        // fileInputRef.current.value = '';
                        setFileKey((prevKey) => prevKey + 1);
                      }}
                      className="btn-close"
                    ></Button>
                  </Col>
                </Row>}
                <Label className="text-danger">
                  (ประเภท PDF, JPEG, PNG และขนาดไฟล์ไม่เกิน 25 MB)
                </Label></>
                }

                
              </Col>
            </FormGroup>
            <FormGroup></FormGroup>
            <FormGroup row style={{ display: "flex", alignItems: "center" }}>
              <Label className="text-end" xxl={3} lg={3} md={3}>
              {leaveConfigFlowData.sendToFinal ? 'ส่งผู้อนุมัติ' : 'ส่งผู้อนุญาต'}
              </Label>
              <Col xl={4} lg={9} md={9}>
                <Input
                  readOnly
                  disabled
                  // value={}
                  value={userInfo?.leader?.user_name ?? ''}
                  type="text"
                  onChange={(e) => handleInputChange(e, "approve_user")}
                />
              </Col>
            </FormGroup>
            <FormGroup row style={{ display: "flex", justifyContent: "end" }}>
              {modalState === "edit" && (
                <Col xl={2} lg={6}>
                  <Button
                      disabled={disableSubmit}
                    className="mt-2"
                    color="success"
                    type="submit"
                    style={{ width: "100%" }}
                  >
                    บันทึกและส่ง
                  </Button>
                </Col>
              )}

              <Col xxl={2} lg={6}>
                <Button
                  onClick={ToggleModalLeaveData}
                  className="mt-2"
                  color="danger"
                  style={{ width: "100%" }}
                >
                  ปิด
                </Button>
              </Col>
            </FormGroup>
          </Form><Row
            className="mt-3"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Col xxl={8}>
              {/* {historyApprove(leaveDataEdit?.form_type, user_position)} */}
              {modalState === "view" && getUserApprove && <ApproveHistory getUserApprove ={getUserApprove} user={user} leaveDataEdit={leaveDataEdit}/>}
            </Col>
          </Row></>)}
          
          
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalViewOrEditTableForm;
